import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import CartCalculator from './pages/CartCalculator';
import PartsCalculator from './pages/PartsCalculator';
import PartsManagement from './pages/PartsManagement';
import BomManagement from './pages/BomManagement';
import UserManagement from './pages/UserManagement';
import Settings from './pages/Settings';
import Categories from './pages/Categories';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={
            <PrivateRoute>
              <Layout><CartCalculator /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="/parts-calculator" element={
            <PrivateRoute>
              <Layout><PartsCalculator /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="/parts" element={
            <PrivateRoute roles={['admin', 'editor']}>
              <Layout><PartsManagement /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="/boms" element={
            <PrivateRoute roles={['admin', 'editor']}>
              <Layout><BomManagement /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="/users" element={
            <PrivateRoute roles={['admin']}>
              <Layout><UserManagement /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="/settings" element={
            <PrivateRoute roles={['admin']}>
              <Layout><Settings /></Layout>
            </PrivateRoute>
          } />

          <Route path="/categories" element={
            <PrivateRoute roles={['admin']}>
              <Layout><Categories /></Layout>
            </PrivateRoute>
          } />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;